import { Carousel } from 'pcln-carousel'
import type { DealDataResponse } from './types'
import PackageCard from './PackageCard'

export default function PackagesDealCarousel({
  deals
}: {
  deals: DealDataResponse[]
}) {
  return (
    <Carousel
      arrowsPositions="top"
      arrowsPosition="side"
      currentSlide={0}
      displayArrowsMobile={false}
      slideSpacing={1}
      visibleSlides={[2.5, 2.5, 3]}
      mobileVisibleSlides={[1.2, 1.2, 2.1]}
    >
      {deals.map((deal, index) => {
        return <PackageCard key={deal.cityImageUrl} index={index} deal={deal} />
      })}
    </Carousel>
  )
}
